// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';

import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '../static/css/base.css';
import '../node_modules/echarts/map/js/world.js'

import App from './App';
Vue.use(ElementUI);
import AFTableColumn from 'af-table-column'
Vue.use(AFTableColumn)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
});

//埋点
router.beforeEach((to, from, next) => {
    try {
        LogCollection.end();
    } catch (e) {}
    next();
});

router.afterEach((to, from) => {
    scrollTo(0, 0); //切换路由 页面回到顶部
    try {
        LogCollection.init();
    } catch (e) {}
    // next();
});

// 提示升级
(function(w) {
    if (!("WebSocket" in w && 2 === w.WebSocket.CLOSING)) {
        var d = document.createElement("div");
        d.className = "browsehappy";
        d.innerHTML = '<div style="width:100%;height:100px;font-size:20px;line-height:100px;text-align:center;background-color:#009900;color:#fff;margin-bottom:40px;">\u4f60\u7684\u6d4f\u89c8\u5668\u5b9e\u5728<strong>\u592a\u592a\u65e7\u4e86</strong>\uff0c\u592a\u592a\u65e7\u4e86 <a target="_blank" href="http://browsehappy.osfipin.com/" style="background-color:#0099FF;border-color: #269abc;text-decoration: none;padding: 6px 12px;background-image: none;border: 1px solid transparent;border-radius: 4px;color:#fff;">\u7acb\u5373\u5347\u7ea7</a></div>';
        var f = function() { var s = document.getElementsByTagName("body")[0]; if ("undefined" == typeof(s)) { setTimeout(f, 10) } else { s.insertBefore(d, s.firstChild) } };
        f()
    }
}(window));


// WEBPACK FOOTER //
// ./src/main.js